import { CircleHelp, LockKeyhole } from 'lucide-react'
import type { ReactNode } from 'react'

import { BrandMark } from '../../components/BrandMark'

interface SubmissionShellProps {
  children: ReactNode
  step: 1 | 2 | 3
  onStepChange: (step: 1 | 2 | 3) => void
  maxStep: 1 | 2 | 3
}

const steps = [
  { number: 1 as const, long: 'Your details', short: 'Details' },
  { number: 2 as const, long: 'Strains & photos', short: 'Photos' },
  { number: 3 as const, long: 'Review', short: 'Review' },
]

export function SubmissionShell({ children, step, onStepChange, maxStep }: SubmissionShellProps) {
  return (
    <main className="submission-shell">
      <aside className="editorial-rail">
        <header className="editorial-rail__header">
          <BrandMark inverted />
          <a className="editorial-rail__help editorial-rail__help--mobile" href="mailto:420@hightimes.com">
            <CircleHelp aria-hidden="true" />
            <span className="sr-only">Submission help</span>
          </a>
        </header>
        <div className="editorial-rail__story">
          <h1>Show us what you grew.</h1>
          <p>
            Send your best nug shots to the High Times editorial team. Keep every strain, credit and photo together.
          </p>
        </div>
        <img
          className="editorial-rail__image"
          src="/images/nugshot-hero.jpg"
          alt="A detailed cannabis flower photographed against black"
        />
        <div className="editorial-rail__privacy">
          <LockKeyhole aria-hidden="true" />
          <span>Originals stay private until selected.</span>
        </div>
      </aside>

      <section className="submission-workspace">
        <header className="submission-workspace__header">
          <a className="submission-help" href="mailto:420@hightimes.com">
            Submission help
          </a>
        </header>
        <nav className="progress-rail" aria-label="Submission progress">
          {steps.map((item) => (
            <button
              key={item.number}
              className={`progress-rail__step ${item.number === step ? 'progress-rail__step--current' : ''}`}
              type="button"
              disabled={item.number > maxStep}
              onClick={() => onStepChange(item.number)}
              aria-current={item.number === step ? 'step' : undefined}
            >
              <span>0{item.number}</span>
              <span className="progress-rail__long">{item.long}</span>
              <span className="progress-rail__short">{item.short}</span>
            </button>
          ))}
        </nav>
        <div className="submission-workspace__content">{children}</div>
      </section>
    </main>
  )
}
